export default "__VITE_ASSET__BUr9qArv__"